import * as React from "react";
import { Avatar, type SxProps, type Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { avatarInitials, type AvatarUserLike } from "@/lib/avatar";
import { palette, typographyTokens } from "@/theme/tokens";
import { Icons } from "./icons";

export type UserAvatarUser = AvatarUserLike & {
  avatar_url?: string | null;
};

type UserAvatarProps = {
  user?: UserAvatarUser | null;
  size?: number;
  sx?: SxProps<Theme>;
};

export function UserAvatar({ user, size = 32, sx }: UserAvatarProps) {
  const initials = avatarInitials(user);
  const image = user?.avatar_url || undefined;

  return (
    <Avatar
      src={image}
      alt={user?.name || user?.email || "Пользователь"}
      sx={[
        (theme) => ({
          width: size,
          height: size,
          flexShrink: 0,
          borderRadius: "50%",
          fontSize: Math.max(10, Math.round(size * 0.36)),
          fontWeight: typographyTokens.weights.semibold,
          letterSpacing: 0,
          color: theme.palette.mode === "dark" ? palette.text.darkPrimary : palette.text.lightPrimary,
          border: "1px solid",
          borderColor:
            theme.palette.mode === "dark"
              ? alpha(palette.primary.main, 0.18)
              : alpha(palette.primary.dark, 0.12),
          background:
            theme.palette.mode === "dark"
              ? `linear-gradient(135deg, ${alpha(palette.primary.main, 0.18)}, ${alpha(palette.accent.cyan, 0.1)})`
              : `linear-gradient(135deg, ${alpha(palette.primary.main, 0.16)}, ${alpha(palette.accent.cyan, 0.08)})`,
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.06)",
          "& img": {
            width: "100%",
            height: "100%",
            objectFit: "cover",
          },
        }),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {initials || <Icons.User size={Math.max(15, Math.round(size * 0.54))} />}
    </Avatar>
  );
}
